// Titles sized «Авто»: in the calendar their font size follows their cell, as large as fits.

// Such a title is wrapped in this span, which older builds simply draw as it is.
const FIT_OPEN = '<span data-fit="true">';
const FIT_CLOSE = '</span>';

export const isFitTitle = (html) => Boolean(html?.startsWith(FIT_OPEN) && html.endsWith(FIT_CLOSE));
export const unwrapFit = (html) => (isFitTitle(html) ? html.slice(FIT_OPEN.length, -FIT_CLOSE.length) : html);
export const wrapFit = (html, fit) => (fit && html ? `${FIT_OPEN}${html}${FIT_CLOSE}` : html);

// A title's text, with its line breaks, from its HTML.
export const titleText = (html) => (html ?? '')
    .replace(/<br\s*\/?>|<\/?(div|p)(\s[^>]*)?>/gi, '\n')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&')
    .replace(/\s*\n\s*/g, '\n')
    .trim();

const MIN_SIZE = 6;
const MAX_SIZE = 64;
const LINE_HEIGHT = 1.15;
const SPACE = 0.28;

// A character's width in em, roughly, in Roboto: capitals are wider, emojis wider still.
const charWidth = (ch) => {
    if (/\p{Extended_Pictographic}/u.test(ch)) return 1.2;
    if (/[A-ZА-ЯЁ0-9]/u.test(ch)) return 0.66;
    return 0.53;
};
const wordWidth = (word) => [...word].reduce((width, ch) => width + charWidth(ch), 0);

// How many lines text takes when wrapped at spaces in lines lineEm em wide, or Infinity when a word is wider
// than a line: the calendar's cells don't break words.
const linesFor = (paragraphs, lineEm) => paragraphs.reduce((lines, words) => {
    let count = 1;
    let used = 0;
    for (const word of words) {
        const width = wordWidth(word);
        if (width > lineEm) return Infinity;
        if (used > 0 && used + SPACE + width <= lineEm) {
            used += SPACE + width;
        } else {
            if (used > 0) count++;
            used = width;
        }
    }
    return lines + count;
}, 0);

// The largest whole font size, in px, at which text fits a box of width × height px. Widths are estimated
// from the characters, so the calendar needs no layout to size its titles.
export const fitFontSize = (text, width, height) => {
    const paragraphs = text.split('\n').map((line) => line.split(/\s+/).filter(Boolean));
    const fits = (size) => linesFor(paragraphs, width / size) * size * LINE_HEIGHT <= height;
    let low = MIN_SIZE;
    let high = MAX_SIZE;
    if (!fits(low)) return MIN_SIZE;
    while (low < high) {
        const mid = Math.ceil((low + high) / 2);
        if (fits(mid)) low = mid;
        else high = mid - 1;
    }
    return low;
};
